import Joyride from "react-joyride";
import "./AppTour.scss";

const AppTour = ({ run, steps, onFinish, callback }) => {
  return (
    <Joyride
      run={run}
      steps={steps}
      callback={callback}
      continuous
      disableScrolling
      hideBackButton
      hideCloseButton
      showSkipButton={false}
      floaterProps={{
        hideArrow: true,
      }}
      styles={{
        options: {
          zIndex: 99999,
        },
        tooltip: {
          borderRadius: 32,
          paddingTop: 4,
          paddingLeft: 14,
          paddingRight: 14,
          paddingBottom: 0,
        },
        buttonNext: {
          display: "none",
        },
      }}
    />
  );
};

export default AppTour;
